import {ReactNode, forwardRef} from 'react';
import clsx from 'clsx';

import s from './styles.module.scss';

interface CardBorderedProps {
  children: ReactNode;
  className?: string;
  blur?: boolean;
}

const CardBordered = forwardRef<HTMLDivElement, CardBorderedProps>(
  ({children, className, blur}, ref) => (
    <div
      ref={ref}
      className={clsx(s['card-bordered'], className, {
        [s['card-bordered--blur']]: blur,
      })}
    >
      {children}
    </div>
  )
);

export default CardBordered;
